import React from 'react';
import { useTranslation } from "react-i18next";

const WithdrawRequestTr = ({ data }) => {
    const { t } = useTranslation();
    return (
        <tr>
            <td data-label={t("withdrawRequestTr.id")}>{data.id}</td>
            <td data-label={t("withdrawRequestTr.date")}>{data.created_at}</td>
            <td data-label={t("withdrawRequestTr.method")}>{data.payment_method}</td>
            <td data-label={t("withdrawRequestTr.amount")}>${data.amount}</td>
            <td data-label={t("withdrawRequestTr.fee")}>${data.fees}</td>
            <td data-label={t("withdrawRequestTr.total")}>${data.amount-data.fees}</td>
            <td data-label={t("withdrawRequestTr.status")}>{data.approved == 1 ? <span className="status-badge ok">{t("withdrawRequestTr.approved")}</span> : <span className="status-badge pending">{t("withdrawRequestTr.pending")}</span>}</td>
            <td data-label={t("withdrawRequestTr.account_info")}>
                {data.payment_method == 'paypal' && data.bank_additional}
                <p className='mb-0 pb-0'>{data.payment_method == 'bank' && data.bank_name}</p>
                <p className='mb-0 pb-0'>{data.payment_method == 'bank' && data.account_number}</p>
                <p className='mb-0 pb-0'>{data.payment_method == 'bank' && data.bank_additional}</p>
                
            </td>
        </tr>
    );
};

export default WithdrawRequestTr;